if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.form.querySelector("[name=id]").disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.notification = document.getElementById("cart-notification");
        this.submitButton = this.querySelector('[type="submit"]');
        this.onBodyClick = this.handleBodyClick.bind(this);
        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");

        this.hideErrors = this.dataset.hideErrors === "true";
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".loading__spinner").classList.remove("hidden");

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        const newFormData = {
          items: [
            {
              id: parseInt(document.getElementsByName("id")[0].value),
              quantity: 1,
            },
          ],
        };
        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        const checkboxes = document.querySelectorAll(
          ".add-on-product-checkbox"
        );
        let hasCheckbox = false;

        checkboxes.forEach(function (checkbox) {
          if (checkbox.checked) {
            newFormData.items.push({
              id: parseInt(checkbox.value),
              quantity: 1,
            });
            hasCheckbox = true;
          }
          // formData.append('items[]',JSON.stringify({
          //       'id': parseInt(checkbox.value),  // variant id
          //       'quantity': 1
          //   }));
        });

        if (this.dataset.directCheckout === "true") {
          config.body = formData;

          fetch(`${routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => {
              if (response.status) {
                publish(PUB_SUB_EVENTS.cartError, {
                  source: "product-form",
                  productVariantId: formData.get("id"),
                  errors: response.errors || response.description,
                  message: response.message,
                });
                this.handleErrorMessage(response.description);
                this.error = true;
                return;
              }

              this.error = false;
              window.location = "/checkout";
            })
            .catch((e) => {
              this.error = true;
              console.error(e);
            })
            .finally(() => {
              if (!this.error) return;
              this.submitButton.classList.remove("loading");
              if (!this.error)
                this.submitButton.removeAttribute("aria-disabled");
              this.querySelector(".loading__spinner").classList.add("hidden");
            });

          return;
        }

        if (hasCheckbox == true) {
          console.log("eeeeee", JSON.stringify(newFormData));
          config.body = newFormData;
          fetch("/cart/add.js", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(newFormData),
          })
            .then((response) => {
              console.log("response.statuuuu", response.status);
              return response.json();
            })
            .then((response) => {
              console.log("response.statu", response);
              console.log("response.statu2", this.cart);

              // if(response.status !== 200){
              //   response.preventDefault();
              //   this.handleErrorMessage(response.description);
              // } else {
              this.handleErrorMessage(response.description);
              // return;

              let cartNotificationContainer = document.getElementById(
                "cart-notification-product"
              );
              cartNotificationContainer.innerHTML = "";
              response.items.forEach((product) => {
                let productHTML = `
              <div style="display: flex;align-items: center;">
                <div class="cart-notification-product__image global-media-settings">
                  <img src="${product.image}" alt="" width="70" height="44" loading="lazy" style="object-fit: contain;">
                </div>
                <div>
                  <h3 class="cart-notification-product__name h4">${product.title}</h3>
                </div>
              </div>
            `;

                cartNotificationContainer.innerHTML += productHTML;
                // }
              });
            })
            .catch((e) => {
              console.error(e);
            })
            .finally(() => {
              this.submitButton.classList.remove("loading");
              $(".header-icon-cart").removeClass("hidden");
              console.log("remove class");

              if (this.cart && this.cart.classList.contains("is-empty"))
                this.cart.classList.remove("is-empty");
              if (!this.error)
                this.submitButton.removeAttribute("aria-disabled");
              this.querySelector(".loading__spinner").classList.add("hidden");

              var cartNotificationProduct = document.querySelector(
                ".cart-notification-product"
              );

              if (
                !cartNotificationProduct ||
                cartNotificationProduct.innerHTML.trim() === ""
              ) {
                //do nothing lol
              } else {
                this.notification.classList.add("animate", "active");
                this.notification.addEventListener(
                  "transitionend",
                  () => {
                    this.notification.focus();
                    trapFocus(this.notification);
                  },
                  { once: true }
                );
                document.body.addEventListener("click", this.onBodyClick);
              }
            });
        } else {
          config.body = formData;

          fetch(`${routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => {
              if (response.status) {
                publish(PUB_SUB_EVENTS.cartError, {
                  source: "product-form",
                  productVariantId: formData.get("id"),
                  errors: response.errors || response.description,
                  message: response.message,
                });
                this.handleErrorMessage(response.description);

                const soldOutMessage =
                  this.submitButton.querySelector(".sold-out-message");
                if (!soldOutMessage) return;
                this.submitButton.setAttribute("aria-disabled", true);
                this.submitButton.querySelector("span").classList.add("hidden");
                soldOutMessage.classList.remove("hidden");
                this.error = true;
                return;
              } else if (!this.cart) {
                window.location = window.routes.cart_url;
                return;
              }

              if (!this.error)
                publish(PUB_SUB_EVENTS.cartUpdate, {
                  source: "product-form",
                  productVariantId: formData.get("id"),
                  cartData: response,
                });
              this.error = false;
              const quickAddModal = this.closest("quick-add-modal");
              if (quickAddModal) {
                document.body.addEventListener(
                  "modalClosed",
                  () => {
                    setTimeout(() => {
                      this.cart.renderContents(response);
                    });
                  },
                  { once: true }
                );
                quickAddModal.hide(true);
              } else {
                this.cart.renderContents(response);
              }
            })
            .catch((e) => {
              console.error(e);
            })
            .finally(() => {
              this.submitButton.classList.remove("loading");
              $(".header-icon-cart").removeClass("hidden");
              console.log("remove class");

              if (this.cart && this.cart.classList.contains("is-empty"))
                this.cart.classList.remove("is-empty");
              if (!this.error)
                this.submitButton.removeAttribute("aria-disabled");
              this.querySelector(".loading__spinner").classList.add("hidden");
            });
        }
      }

      handleBodyClick(evt) {
        const target = evt.target;
        if (
          target !== this.notification &&
          !target.closest("cart-notification")
        ) {
          const disclosure = target.closest("details-disclosure, header-menu");
          this.activeElement = disclosure
            ? disclosure.querySelector("summary")
            : null;
          this.close();
        }
      }

      close() {
        this.notification.classList.remove("active");
        document.body.removeEventListener("click", this.onBodyClick);

        removeTrapFocus(this.activeElement);
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
